var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"outline-none py-1 px-3 border-0 flex justify-between rounded-full transition-all transform hover:scale-105",class:[ _vm.active ? 'bg-green-700 text-green-100' : 'bg-green-50 text-green-900 hover:bg-green-200' ]},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }